<template>
<div id="top" style="background: #fff">
        <div class="fixed-top">
            <div class="col-12 d-flex flex-row justify-space-between align-center" style="background: #012B20;;">
                <div class="col-0"></div>
                <div class="col-2 logo">
                    <router-link to="/"> <img src="logo.png" alt="Logo"> </router-link>
                </div>
                <div class="col-8 col-lg-6 d-flex flex-row justify-space-around align-center menu-bar">
                    <div class="menu">
                        <a href="#home">Home</a> 
                    </div>
                    <div class="menu">
                        <a href="#core-values">Core Values</a> 
                    </div>
                    <div class="menu">
                        <a href="#aboutus">About Us</a> 
                    </div>
                    <div class="menu">
                        <a href="#services">Services</a> 
                    </div>
                    <div class="menu">
                        <a href="#contact">Contact Us</a> 
                    </div>
                </div>
                <div class="col-2 col-lg-2">
                    <div class="menu-bar1">
                        <span>
                            <i class="fa fa-bars" aria-hidden="true"></i>
                        </span>
                        <Transition>
                            <div class="submenu-bar1">
                                <a href="#home" class="sub-menu1">Home</a> 
                                <a href="#core-values" class="sub-menu1">Core Values</a> 
                                <a href="#aboutus" class="sub-menu1">About Us</a>
                                <a href="#services" class="sub-menu1">Services</a>                      
                                <a href="#contactus" class="sub-menu1" >Contact Us</a>  
                            </div>
                        </Transition>
                    </div>
                </div>
                <div class="col-0"></div>
            </div>
        </div>
       
        <div id="home" class="col-lg-12 col-sm-12 banner position-relative">
            <div class="overlay"></div>
            <div class="col-0"></div>
            <div class="col-lg-7 col-sm-12 btn-style text-white banner-copy">
                <div id="textCarousel" class="carousel slide text-white" data-bs-ride="carousel" data-bs-interval="3000">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <h1>Welcome to<br>PlePower</h1>
                            <h4>
                                PlePower is a digital utility app that enables you to conveniently purchase electricity tokens for homes and offices across Nigeria.

                            </h4>
                           
                        </div>
                        <div class="carousel-item">
                            <h1>Fast & Reliable<br>Bill Payments</h1>
                            <h4>
                                Enjoy seamless payment for power, cable TV, airtime and more — anytime, anywhere.
                            </h4>
                        </div>
                        <div class="carousel-item">
                            <h1>Trusted by Thousands<br>Across Nigeria</h1>
                            <h4>
                                Join a growing community using PlePower for simple, smart, and secure transactions.
                            </h4>
                        </div>
                    </div>
                   
                </div>

                <!-- <button id="core-values" class="btn btn-success mt-4" @click="get_started">
                 Get Started
                </button> -->
                <h3 class="text-white pt-4" style="font-weight: bold;">Need help? Call <a :href="phoneLink" class="text-white">{{ company_phone }}</a></h3>
                <p class="text-bottom">
                    
                    PlePower does not store your payment details or offer financial services.
                </p>
            </div>

            <div class="col-lg-5 col-sm-12 banner-side">
                <div class="banner-login-card">
                    <div class="banner-login-header">
                        <p class="eyebrow">User Login</p>
                        <h3>Sign in to your account</h3>
                        <span>Manage electricity, airtime, data and TV subscriptions in one place.</span>
                    </div>
                    <div class="banner-login-form">
                        <!-- <label for="homepage-username">Username</label> -->
                        <input id="homepage-username" type="text" class="form-control banner-input" placeholder="Enter phone number or email" v-model="username">

                        <!-- <label for="homepage-password">Pin</label> -->
                        <input id="homepage-password" type="password" class="form-control banner-input" placeholder="Enter pin" v-model="password">

                        <div class="banner-login-links">
                            <router-link to="/forgot-password">Forgot pin?</router-link>
                            <router-link to="/register">Create account</router-link>
                        </div>

                        <button class="btn btn-success banner-login-button" :disabled="isLoginButtonDisabled" @click="login()" v-if="!loginLoading">
                            Login
                        </button>
                        <button class="btn btn-success banner-login-button" type="button" disabled v-if="loginLoading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        </button>
                    </div>
                </div>
                <!-- <div class="img-style">
                    <img src="../assets/bg.png" alt="" />
                </div> -->
            </div>
        </div>
        <div id="core-values"  class="pa-5 core-values">
            <div class="guarantee">      
                <div class="guarantee-icon">
                    <i class="fa fa-wrench size-all"></i>
                </div>
                <div class="guarantee-content">
                    <p class="guarantee-label">Built for speed</p>
                    <h3>Automated Services</h3> 
                    <span>We use modern technology to process your transactions quickly and consistently.</span>
                </div>
            </div>
            <div class="guarantee">      
                <div class="guarantee-icon">
                    <i class="fa fa-check size-all"></i>
                </div>
                <div class="guarantee-content">
                    <p class="guarantee-label">Service standard</p>
                    <h3>Quality Services</h3> 
                    <span>Every payment experience is designed around reliability, efficiency and customer satisfaction.</span>
                </div>
            </div> 
            <div class="guarantee">
                <div class="guarantee-icon">
                    <i class="fa fa-desktop size-all"></i>
                </div>
                <div class="guarantee-content">
                    <p class="guarantee-label">Dependable platform</p>
                    <h3>Reliable</h3>
                    <span>PlePower is built for dependable performance, helping you complete each transaction with confidence.</span>
                </div>
            </div> 
            <div class="guarantee"> 
                <div class="guarantee-icon">
                    <i class="fa fa-lock size-all"></i>
                </div>
                <div class="guarantee-content">
                    <p class="guarantee-label">Protected checkout</p>
                    <h3>Secured Payment</h3>
                    <span>Payments are handled securely through trusted third-party providers for added peace of mind.</span>
                </div>
            </div>
        </div>
        <div id="aboutus" class="col-lg-12 about">
            <div class="overlay2"></div>
            <div class="col-lg-7 col-sm-12 about-copy">
                <p class="about-label">About PlePower</p>
                <h2>Simple, dependable utility payments for everyday life.</h2>
                <p class="about-text">PlePower is a digital utility platform built to make bill payments easier for homes, businesses and individuals across Nigeria.</p>
                <p class="about-text">From electricity tokens to airtime, data and TV subscriptions, we help customers complete essential payments quickly, securely and with confidence.</p>
                <div class="about-highlights">
                    <div class="about-highlight">
                        <strong>Fast processing</strong>
                        <span>Complete transactions in a few simple steps.</span>
                    </div>
                    <div class="about-highlight">
                        <strong>Trusted support</strong>
                        <span>Get help when you need it from a responsive team.</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-5 col-sm-12 about-cta-panel">
                <div class="about-cta-card">
                 <p class="cta-eyebrow">Get Started</p>
                 <h4 class="try-us">Try PlePower today</h4>
                 <p class="cta-text">Create your account or sign in to start paying for electricity, airtime, data and subscriptions with ease.</p>
                 <div class="btn-account">
                    
                    <!-- <button @click="sign_up" class="btn btn-success sign-up"><i class="fa fa-user"></i> Sign Up</button> -->
                 </div>
                 <span class="cta-note">Secure access, fast checkout and reliable service in one place.</span>
                </div>
            </div>
         </div>
        <div id="services" class="col-lg-12 pt-3 bg-style">
            <div class="overlay1"></div>
            <div class="col-lg-4 col-sm-12 pt-4 pa-2 services-visual">
                <div class="services-visual-card">
                    <img src="../assets/1.png" alt="">
                </div>
            </div>
            <div class="col-lg-5 col-sm-12 platform-1">
                <div class="platform">
                    <p class="section-eyebrow">Our Services</p>
                    <h2>Everything you need for everyday utility payments.</h2>
                    <p class="services-copy">Our platform is built for fast, automated delivery across the services you use most.</p>
                    <div class="services-grid">
                        <span class="select-item">
                            <i class="fas fa-lightbulb"></i> Electricity Payment
                        </span>
                        <span class="select-item">
                            <i class="fas fa-mobile-alt"></i> Airtime Topup
                        </span>
                        <span class="select-item">
                            <i class="fas fa-wifi"></i> Buy Data
                        </span>
                        <span class="select-item">
                            <i class="fas fa-satellite-dish icon"></i> DStv Subscription
                        </span>
                        <span class="select-item">
                            <i class="fas fa-satellite-dish icon"></i> GOtv Subscription
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-sm-12 pt-4 mobile-img d-flex flex-column">
                <img src="../assets/mobile.jpg" alt="">
                <div class="d-flex flex-column align-items-start mobile-store mb-5">
                    <p class="pt-2">Download the PlePower mobile app for faster access on the go.</p>
                    <a href="https://play.google.com/store/apps/details?id=com.prolegacy.plepower_app"> <img src="../assets/google-play.png" alt="" class="google-play"></a>
                </div>
            </div>
        </div>        
        <div id="contact" class="col-lg-12 contact">
            <div class="col-lg-4 col-sm-12 bd contact-intro">
               
                <h4 class="support-text">Support that stays close when you need help.</h4>
                <p class="support-team-text">Our support team is available to guide you through payments, subscriptions and account-related questions.</p>
                <div class="contact-feature-list">
                    <div class="contact-feature">
                        <i class="fa fa-headphones"></i>
                        <span>Responsive customer support</span>
                    </div>
                    <div class="contact-feature">
                        <i class="fa fa-clock-o"></i>
                        <span>Help with urgent service issues</span>
                    </div>
                </div>
           </div>
            <div class="col-lg-4 col-sm-12 contact-banner bd">
                <h4>Contact Form</h4>
                 <label>Fullname *</label>
                 <input class="form-control" type="text" name="" v-model="fullname" id="" placeholder="Enter your fullname">
                 <label>Email *</label>
                 <input class="form-control" type="email" name="" v-model="email_address" id="" placeholder="Enter email address">
                 <label>Phone *</label>
                 <input class="form-control" type="text" name="" v-model="phone_number" id="" placeholder="Enter phone number">
                 <label>Mesasge *</label>
                 <textarea class="form-control" name="" v-model="message" id="" cols="3" rows="4" placeholder="Tell us how we can help you"></textarea>
                 <br>
                 <button id="submit4" class="btn btn-success btn-sm input-contact" :disabled="isSubmitButtonDisabled" @click="submit_form()" v-if="!loading">Send message</button>
                 <button class="btn btn-success btn-sm input-contact" type="button" disabled v-if="loading">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                 </button>
                
            </div>
            <div class="col-lg-4 col-sm-12 bd contact-details-card">
                 <p class="section-eyebrow">Contact Us</p>
                 <br>
                 <div class="contact-detail-item">
                    <h4><i class="fa fa-envelope" aria-hidden="true"></i> Email Us</h4>
                    <p class="contact-text">Our dedicated team will help you out<br><span class="text-secondary"><a href="mailto:info@plepower.com.ng" class="text-secondary">{{ company_email }}</a></span></p>
                 </div>
                 <div class="contact-detail-item">
                    <h4><i class="fa fa-map-marker" aria-hidden="true"></i> Our Office</h4>
                    <p class="contact-text">Visit us today at our office headquarter<br> <span class="text-secondary">{{ company_address }}</span></p>
                 </div>
                 <div class="contact-detail-item">
                    <h4><i class="fa fa-headphones" aria-hidden="true"></i> Help Desk</h4>
                    <p class="contact-text">You can reach out via call or sms 24/7.<br> <span class="text-secondary"><a :href="phoneLink" class="text-secondary"><i class="fa fa-phone" aria-hidden="true"></i> {{ company_phone }}</a></span></p>
                 </div>
                 <div class="contact-action-links">
                    <a href="#contact" class="contact-action-link live-chat-link">
                        <i class="fa fa-comments" aria-hidden="true"></i>
                        Live Chat
                    </a>
                    <a :href="whatsappLink" target="_blank" rel="noopener noreferrer" class="contact-action-link whatsapp-link">
                        <i class="fa fa-whatsapp" aria-hidden="true"></i>
                        WhatsApp
                    </a>
                 </div>
                 <div class="social-connect-section">
                    <p class="social-connect-title">Connect with us</p>
                    <div class="social-connect-links">
                        <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Facebook" class="social-connect-link facebook-link">
                            <i class="fa fa-facebook" aria-hidden="true"></i>
                        </a>
                        <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Instagram" class="social-connect-link instagram-link">
                            <i class="fa fa-instagram" aria-hidden="true"></i>
                        </a>
                        <a href="#" target="_blank" rel="noopener noreferrer" aria-label="Twitter" class="social-connect-link twitter-link">
                            <i class="fa fa-twitter" aria-hidden="true"></i>
                        </a>
                        <a href="#" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" class="social-connect-link linkedin-link">
                            <i class="fa fa-linkedin" aria-hidden="true"></i>
                        </a>
                        <a href="#" target="_blank" rel="noopener noreferrer" aria-label="YouTube" class="social-connect-link youtube-link">
                            <i class="fa fa-youtube-play" aria-hidden="true"></i>
                        </a>
                    </div>
                 </div>
            </div>
        </div>
        <div class="content-footer" id="contactus">
            <div class="contact-info footer-img">
                <img src="logo.png" alt="">
                <p>Fast, reliable and secure utility payments for homes and businesses across Nigeria.</p>
            </div>
            <div class="contact-info">
                <p class="contact-title">Our Services</p>

                <p>
                    <i class="fa fa-bolt" aria-hidden="true"></i>
                    Electricity Subscription
                </p>

                <p>
                    <i class="fa fa-phone" aria-hidden="true"></i>
                    Airtime Purchase
                </p>

                <p>
                    <i class="fa fa-wifi" aria-hidden="true"></i>
                    Data Purchase
                </p>

                <p>
                    <i class="fa fa-television" aria-hidden="true"></i>
                    Cable TV Subscription
                </p>
            </div>
            <div class="contact-info">
                <p class="services-title">Useful Links</p>
                <!-- <p><a href="#" target="_blank">Vendor Hub</a> </p> -->
                <p><router-link to="#">Terms & Conditions</router-link></p>
                <p><router-link to="/privacy-policy">Privacy Policy</router-link></p>
                <!-- <p><router-link to="/terms-and-conditions#top">Terms & Conditions</router-link></p>
                <p><router-link to="/privacy-policy#top">Privacy Policy</router-link></p> -->
            </div>
            <div class="contact-info">
                <p class="services-title">Socials</p>
                <p> <span><a href="#" target="_blank"><i class="fa fa-facebook-square"></i> Facebook</a></span> </p>
                <p> <span><i class="fa fa-twitter-square"></i> Twitter </span></p>
                <p> <span><i class="fa fa-instagram"></i> Instagram</span></p>
            </div>
        </div>
        <div class="content-footer">
            <p class="copyright">&copy;{{ new Date().getFullYear() }} PlePower. All rights reserved. </p>
        </div>
        <!-- <div class="contact-support">
          <a href="https://wa.me/2347051525555" target="_blank"><img src="../assets/support.png" alt=""></a> 
        </div>   -->
        <a href="#top">  
        <div class="top">
            <i class="fa fa-arrow-up"></i>
        </div>  
        </a>   
</div>
</template>
<script>
import swal from 'sweetalert2';
import $ from 'jquery';

export default {
    
    data() {
    return {
        logo_url: process.env.VUE_APP_API_LOGO,
        company_phone: '',
        company_email: '',
        company_name: '',
        company_address: '',
        loading: false,
        loginLoading: false,
        username: '',
        password: '',
        fullname: '',
        email_address: '',
        phone_number: '',
        message: '',
        show: false,
        title: 'PlePower |  Electricity, Buy Airtime, Internet Data and Cable TV',
        showImage: 1,
        exists: false,
        showBanner: true, 
        items: [
          {
            src: process.env.VUE_APP_API_BANNER,
          },
          {
            src: process.env.VUE_APP_API_BANNER2,
          },       
        ],
        showTop: true,
        lastScrollTop: 0
    };
  },

  mounted() {

    $(document).ready(function() {
    $(window).scroll(function() {
        if ($(this).scrollTop() > 100) {
            $('.top').fadeIn();
           document.getElementById('top-header').style.display = 'none'
          
        } else {
            $('.top').fadeOut();
            if ($(this).scrollTop() == 0) {
                document.getElementById('top-header').style.display = 'flex'
            }
        }
       
    });

    $('.top').click(function() {
        $('html, body').animate({scrollTop: 0}, 800);
        return false;
        });
    });

    setInterval(() => {
        this.showImage = this.showImage === 2 ? 1 : this.showImage + 1;
    }, 10000); // Toggle images every 3 seconds

    document.title = this.title

    this.config_data()
   
  },
  beforeDestroy() {
   
  },
    created(){

    },
  computed: {
    isSubmitButtonDisabled() {
        return (
        this.fullname === '' ||
        this.email_address === '' ||
        this.phone_number === '' ||
        this.message === '' 
        );
    },
    isLoginButtonDisabled() {
        return (
        this.username === '' ||
        this.password === ''
        );
    },
    phoneLink() {
        const phone = (this.company_phone || '').replace(/\D/g, '');
        return phone ? `tel:${phone}` : 'tel:';
    },
    whatsappLink() {
        const phone = (this.company_phone || '').replace(/\D/g, '');
        return phone ? `https://wa.me/${phone}` : 'https://wa.me/';
    }
  },

  methods: {
    
    get_started(){
        this.$router.push('/register')
    },
    sign_in(){
        this.$router.push('/')
    },
    sign_up(){
        this.$router.push('/register')
    },
    async login() {
            try {

                this.loginLoading = true
                const response =  await this.$http.post('/user-login', {
                    phone_number: this.username,
                    password: this.password
                });

                this.loginLoading = false

                if( !response.data.success ){
                    swal.fire({
                        icon: 'error',
                        title: 'Error',
                        width: 450,
                        height: 5,
                        text: response.data.message,
                    })
                    return;
                }

                let token = response.data.token;
                await localStorage.setItem("wertyuiojhdfghhdrtfyguh", token)
                await localStorage.setItem("firstname", response.data.user_profile[0].firstname)
                await localStorage.setItem("lastname", response.data.user_profile[0].lastname)
                await localStorage.setItem("email", response.data.user_profile[0].email_address)
                await localStorage.setItem("dummy_email", response.data.user_profile[0].dummy_email)
                await localStorage.setItem("phone", response.data.user_profile[0].phone_number)
                await localStorage.setItem("userid", response.data.user_profile[0].userid)
                await localStorage.setItem("user_role", response.data.user_profile[0].user_role)

                this.$router.push('/home')

            } catch (err) {
                console.log(err);
                swal.fire({
                    icon: 'error',
                    title: 'Error',
                    width: 450,
                    height: 5,
                    text: err.response ? err.response.data.message : err.message,
                })
                this.loginLoading = false
                return;
            }
    },
    async submit_form() {
            try {

                this.loading = true

                const response = await this.$http.post('/send-message', {
                  fullname: this.fullname,
                  email_address: this.email_address,
                  phone_number: this.phone_number,
                  message: this.message
                })

                this.loading = false

                if( !response.data.success ){
                    swal.fire({
                        icon: 'error',
                        title: 'Error',
                        width: 450,
                        height: 5,
                        text: response.data.message,
                    })
                    return;
                }

                swal.fire({
                    icon: 'success',
                    title: 'Successful',
                    width: 450,
                    height: 5,
                    text: response.data.message,
                })

                this.fullname = ''
                this.email_address = ''
                this.phone_number = ''
                this.message = ''

                return;
               
            } catch (err) {
              console.log(err);
        }
    },

    async config_data() {
        const response = await fetch('/config.json');
        const configData = await response.json();

        this.company_phone = configData.phoneNumber
        this.company_email = configData.emailAddress
        this.company_address = configData.address

        }
  },
    
}
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Mulish:wght@300;400;500;700&display=swap');

a{
    text-decoration: none;
}
.text-bottom{
    font-size: 15px;
}
/* Define slide-in and slide-out animations */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s ease, opacity 0.5s ease;
}
.slide-enter {
  transform: translateX(-100%);
  opacity: 0;
}
.slide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
 .v-enter-from {
    opacity: 0;
    translate: -100px 0;
  }
  .v-enter-to {
    opacity: 1;
    translate: 0 0;
  }
  .v-leave-from {
    opacity: 1;
    translate: 0 0;
  }
  .v-leave-to {
    opacity: 0;
    translate: 100px 0;
  }
 
.top-header{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0.3rem;
    padding-left: 5%;
    padding-right: 5%;
    color: #012B20;
    background: #fff;
    box-shadow: 0 2px 4px -3px rgba(0, 0, 0, 0.4);
    font-weight: 500;
    font-size: 13px;
}
.haddress{
    display: flex;
    flex-direction: column;
    font-family: Mulish;

    span {
        a {
            text-decoration: none;
            color: #012B20;
        }
    }
}
.htime{
    display: flex;
    flex-direction: column;
    font-family: Mulish;
}
.hsocial{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    span{
        margin: 10px;
    }

    a{
        color: #000;
    }
}
.core-values{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    gap: 1.25rem;
    padding: 4rem 5% !important;
    background: linear-gradient(180deg, #f5f8f6 0%, #e9efeb 100%);

    h3{
        font-family: Mulish;
        font-size: 23px;
        font-weight: 800;
        color: #16372d;
        text-align: left;
        margin: 0;
    }
    span{
        font-family: Mulish;
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        color: #5d7269;
        line-height: 1.7;
    }
}
.guarantee{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    flex: 1;
    min-height: 280px;
    border: 1px solid rgba(25, 63, 48, 0.08);
    border-radius: 24px;
    background: rgba(255, 255, 255, 0.96);
    padding: 1.6rem;
    box-shadow: 0 18px 50px rgba(7, 30, 22, 0.08);
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.guarantee:hover{
    transform: translateY(-6px);
    box-shadow: 0 24px 60px rgba(7, 30, 22, 0.14);
}
.guarantee-icon{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 62px;
    height: 62px;
    border-radius: 18px;
    background: linear-gradient(135deg, #24562B 0%, #659610 100%);
    color: #fff;
    margin-bottom: 1.25rem;
}
.size-all{
    font-size: 24px;
}
.guarantee-content{
    display: flex;
    flex-direction: column;
    gap: 0.85rem;
}
.guarantee-label{
    margin: 0;
    font-family: Mulish;
    font-size: 10px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    color: #6a8a7c;
}
.btn-success{
    border: solid 0;
    height: 50px;
    background-color: #012B20;
}
.btn-success:hover{
    background: #000;
    border: solid 0;
    color: #FFF;
    height: 50px;
}
.modal-fade-enter-active, .modal-fade-leave-active {
    transition: opacity 1.1s;
  }
  .modal-fade-enter, .modal-fade-leave-to /* .modal-fade-leave-active in <2.1.8 */ {
    opacity: 0.1;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0;
  }
.header {
    background: #F2F2F2;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 70px;
    font-size: 10px;
    font-weight: 400;
    box-shadow: 0 4px 6px -3px rgba(0, 0, 0, 0.3);
    color: #fff;
    padding-left: 5%;
    padding-right: 5%;
}
.sidebar{
    display: none;
}
.fa-bars {
    display: none;
}
.menu-bar {
    height:70px;
}

.menu-bar1{
    display:none;
 }
 .submenu-bar1{
    display:none;

    .submenu-bar{
        display: flex;
        flex-direction: column;
        left: 0;
        font-family: Mulish;
        font-size: 13px;
        border-right: solid 1px rgba(0, 0, 0, 0.3);;
        bottom: 0;
        height: 100vh;
    
        a{
            text-decoration: none;
            color: #012B20;
        }
    }
 }

.logo{
    img{ width: 40%; }
}

.menu > a {
    color: #fff;
    font-weight: 800;
    font-family: Mulish;
}
.menu:hover {
    cursor: pointer;
}
.fixed-top{
    z-index: 9999;
    background: #fff;
}
.banner{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
    padding: 9.5rem 5% 3rem;
    //padding-top: 6.5rem;
    bottom: 0;
    font-family: Mulish;
    font-size: 18px;
    overflow: hidden;
    position: relative;
    backdrop-filter: blur(16px);
    background: url(../assets/bg.jpg) no-repeat fixed center;
    background-size: cover;
      
    h1{
        font-family: Mulish;
        font-weight: 700;
        font-size: 60px;
        color: #fff;
        text-align: left;
    }
    h4{
        font-family: Mulish;
        font-weight: 400;
        font-size: 16px;
        color: #fff;
        text-align: left;
       // text-shadow: 0px 1px #000; 
    }
    .btn-style{
        font-family: Mulish;
        text-align: left;

    }
    .img-style{
        padding: 0;
        display: flex;
        justify-content: center;
        img{
            width: 80%;
            max-width: 280px;
            border: solid 1px #02352A;
            border-radius: 4px
        }
    }
}  
.banner-copy{
    position: relative;
    z-index: 1;
}
.banner-side{
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
}
.banner-login-card{
    width: 100%;
    max-width: 420px;
    padding: 2rem;
    border-radius: 24px;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.25);
    color: #012B20;
}
.banner-login-header{
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    margin-bottom: 1.4rem;

    .eyebrow{
        margin: 0;
        font-size: 11px;
        font-weight: 800;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: #659610;
    }

    h3{
        margin: 0;
        font-size: 28px;
        font-weight: 800;
        color: #012B20;
    }

    span{
        font-size: 14px;
        line-height: 1.6;
        color: #45635b;
    }
}
.banner-login-form{
    display: flex;
    flex-direction: column;
    gap: 0.75rem;

    label{
        font-size: 13px;
        font-weight: 700;
        color: #012B20;
    }
}
.banner-input{
    height: 52px;
    border: 1px solid #d9e2dd;
    border-radius: 14px;
    font-size: 14px;
    box-shadow: none;
}
.banner-login-links{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 1rem;
    margin-top: 0.35rem;
    margin-bottom: 0.35rem;

    a{
        font-size: 16px;
        font-weight: 700;
        color: #24562B;
    }
}
.banner-login-button{
    width: 100%;
    height: 50px;
    border-radius: 14px;
    font-weight: 700;
}
.overlay {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #012b20; /* Change the color and opacity here */
    opacity: 0.9;
  }
  .overlay1 {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(224, 233, 225, 0.956)/* Change the color and opacity here */
  }
.bg-style{
    display:flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 1.5rem;
    position: relative;
    padding: 4.5rem 5%;
    backdrop-filter: blur(16px);
    background: url(../assets/bg1.jpg) no-repeat center;
    background-size: cover;

    .services-visual-card{
        position: relative;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1.5rem;
        border-radius: 28px;
        background: rgba(255, 255, 255, 0.72);
        box-shadow: 0 20px 55px rgba(9, 32, 23, 0.12);
    }

    .mobile-img{
        position: relative;
        z-index: 1;
        h2{
            font-size: 15px; 
            font-weight: bold;
            font-family: Mulish;
            color: #012B20;
        }
        p{
            font-size: 12px; 
            font-weight: 400;
            font-family: Mulish;
            color: #012B20;
            line-height: 1.7;
        }
        img{
            width: 100%;
            max-width: 240px;
            border-radius: 22px;
            box-shadow: 0 18px 44px rgba(8, 24, 18, 0.16);
         }
         .google-play{
            margin-top: 0.35rem;
            text-align: left;
            width: 48%;
            cursor: pointer;
         }
    }
    
    img{
      
    }
    
    .platform{
        display:flex;
        flex-direction: column;
        gap: 1rem;
        padding: 2.4rem;
        position: relative;
        z-index: 1;
        border-radius: 28px;
        background: rgba(255, 255, 255, 0.86);
        box-shadow: 0 20px 55px rgba(9, 32, 23, 0.12);

    h2{
        font-size: 34px; 
        font-weight: 800;
        font-family: Mulish;
        color: #012B20;
        margin: 0;
    }
    span{
        font-size: 14px; 
        font-weight: 350;
        font-family: Mulish;
    }
    .services-copy{
        margin: 0;
        font-size: 15px;
        line-height: 1.8;
        color: #546862;
    }
    .services-grid{
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 0.85rem;
    }
}
}

.section-eyebrow{
    margin: 0;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #659610;
}

.card{
    border: solid 0px;
    border-bottom: solid 1px #fff;
    background: #fff;
   
}
.card-link{
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    font-size: 17px; 
    font-weight: 600;
    font-family: Mulish;
    height: 20px;
    color: #000;
   
}
.card-header{
    border-bottom: solid 1px #fff;
}
.card-body{
    font-size: 14px; 
    font-family: Mulish;
    color: #012B20;
}
.badge-secondary{
    background: #012B20;
}

.bg-task{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 2.2rem;
    height: auto;
   // box-shadow: 1px 2px 4px rgba(0, 0, 0, .5);
    background-image: linear-gradient(-180deg, #012B2032, #fff);

    h2{
        font-size: 40px; 
        font-weight: 600;
        font-family: Mulish;

    }
    img{
        width: 90%;
    }
}
.select-item{
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin: 0;
    padding: 1rem 1.1rem;
    font-size: 16px !important; 
    font-weight: 700;
    font-family: Mulish;
    color: #012B20;
    border-radius: 18px;
    background: #f4f8f5;
    border: 1px solid rgba(25, 63, 48, 0.08);

    i{
        font-size: 18px;
        color: #24562B;
    }
}
.slider {
    display:flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    //height: 500px; 
    font-size: 45px; 
    font-weight: bold;
    text-shadow: 0px 1px #000; 
    font-family: Mulish;
    text-align: center;
  }
.sample-product-subtitle{
    font-size: 20px !important; 
    text-shadow: 0px 0px #f5f9f711; 
    text-align: center;
    width: 50%;
    color: #fff;
    font-weight: 300 !important;
  }
.action-botton{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 40px;
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
}
.action-botton2{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100px;
    height: 40px;
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
}
.content-header{
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    margin: 30px;
    font-family: Mulish;
    font-size:17px;
    font-weight: 500;
    color: #000;
    text-transform: uppercase;
    span{
        font-size:20px;
        color: #800080e6;
        font-weight: bold;
    }
  }
  .content-services{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background: #fff !important;
  }
  .content-row{
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 90%;
  }
  .content-items{
    box-sizing: border-box;
    width: 100%;
    height: 250px;
    box-shadow: -1px -1px 4px #ccc;
    border-radius: 4px;
    margin: 10px;
    padding: 15px;
    text-align: center;
  
    p{
      font-family: Mulish;
      font-size:20px;
      font-weight: 700;

      .fa-handshake-o{
        font-size:50px;
        color: #800080e6;
      }
      .fa-wallet{
        font-size:50px;
        color: #800080e6;
      }
      .fa-graduation-cap{
        font-size:50px;
        color: #800080e6;
      }
      .fa-leaf{
        font-size:50px;
        color: #800080e6;
      }
    }
  
    .items-text {
      font-family: Mulish;
      font-size:14px;
      font-weight: 500;
      text-align: center;
    }
  
  }
  .overlay2 {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    //background: #33aacb14;
  }
  .about{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    gap: 2rem;
    bottom: 0;
    font-family: Mulish;
    background-size: cover;
    margin-top: 0px;
    min-height: 360px;
    padding: 4.5rem 5%;
    background: linear-gradient(180deg, #ffffff 0%, #f3f7f4 100%);

    .about-copy{
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 1rem;
        position: relative;
        z-index: 1;
    }

    .about-label{
        margin: 0;
        font-size: 12px;
        font-weight: 800;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: #659610;
    }

    .try-us{
        font-family: Mulish;
        font-size: 28px;
        font-weight: 800;
        color: #012B20;
        margin: 0;
    }
   
    .btn-account{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-content: center;
        gap: 0.75rem;

        .sign-in{
            font-family: Mulish;
            font-size: 16px;
            font-weight: bold;
            border: solid 0px #ccc;
            border-radius: 999px;
            background: #659610;
            min-width: 140px;
            margin-bottom: 10px;
            padding: 0.85rem 1.2rem;
        }
        .sign-up{
            font-family: Mulish;
            font-size: 16px;
            font-weight: bold;
            border: solid 0px #ccc;
            border-radius: 999px;
            background: #012B20;
            min-width: 140px;
            padding: 0.85rem 1.2rem;
        }
    }

    h2{
        font-family: Mulish;
        font-weight: 800;
        font-size: 38px;
        color: #012B20;
        margin: 0;
    }

    h4{
        font-family: Mulish;
        font-size: 15px;
        font-weight: bold;
        text-align: left;
    }
    p{
        font-family: Mulish;
        font-size: 16px;
        color: #4f645c;
        margin: 0;
    }
    .about-text{
        max-width: 640px;
        line-height: 1.8;
    }
    .about-highlights{
        display: flex;
        flex-direction: row;
        gap: 1rem;
        margin-top: 0.5rem;
    }
    .about-highlight{
        display: flex;
        flex-direction: column;
        gap: 0.35rem;
        padding: 1rem 1.1rem;
        border-radius: 18px;
        background: rgba(255, 255, 255, 0.86);
        border: 1px solid rgba(25, 63, 48, 0.08);
        box-shadow: 0 12px 30px rgba(7, 30, 22, 0.05);

        strong{
            font-size: 15px;
            color: #16372d;
        }

        span{
            font-size: 13px;
            color: #62746d;
        }
    }
    .about-cta-panel{
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 1;
    }
    .about-cta-card{
        display: flex;
        flex-direction: column;
        gap: 1rem;
        width: 100%;
        max-width: 420px;
        padding: 2rem;
        border-radius: 26px;
        background: linear-gradient(145deg, #ffffff 0%, #f4f8f5 100%);
        border: 1px solid rgba(25, 63, 48, 0.08);
        box-shadow: 0 20px 55px rgba(7, 30, 22, 0.1);
    }
    .cta-eyebrow{
        font-size: 11px;
        font-weight: 800;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: #659610;
    }
    .cta-text{
        line-height: 1.7;
    }
    .cta-note{
        font-size: 13px;
        color: #6c7d77;
    }
  }

  .bd{
    padding: 1.5rem;
  }
 
  .contact{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    gap: 1.5rem;
    padding: 4.5rem 5%;
    height: auto;
    bottom: 0;
    font-family: Mulish;
    font-size: 10px;
    background: linear-gradient(180deg, #ffffff 0%, #f5f8f6 100%);
    color: #012B20 !important;
    background-size: cover;
    margin-top: 0px;
    height: auto;

    p{
        a{
            text-decoration: none;
            color: #ccc;
        }
    }

    .support-text{
        font-family: Mulish;
        font-size: 24px;
        font-weight: 800;
        text-align: left;
    }
    .support-team-text{
        font-family: Mulish;
        font-size: 12px;
    }
    h4{
        font-family: Mulish;
        font-size: 18px;
        font-weight: 700;
        text-align: left;
    }
    span{
        font-family: Mulish;
        font-size: 11px;
        font-weight: 550;
        color: #3ea4c9c9;
    }
    img{
        width: 100%;
    }
  }
  .contact-intro,
  .contact-banner,
  .contact-details-card{
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(25, 63, 48, 0.08);
    border-radius: 24px;
    box-shadow: 0 18px 50px rgba(7, 30, 22, 0.08);
  }
  .contact-feature-list{
    display: flex;
    flex-direction: column;
    gap: 0.9rem;
    margin-top: 1.2rem;
  }
  .contact-feature{
    display: flex;
    align-items: center;
    gap: 0.8rem;
    padding: 0.95rem 1rem;
    border-radius: 16px;
    background: #f4f8f5;
    color: #16372d;
    font-weight: 700;

    span {
        font-size: 18px;
         color: #24562B;
    }

    i{
        color: #24562B;
        font-size: 18px;
    }
  }
  .contact-detail-item + .contact-detail-item{
    margin-top: 1.4rem;
    padding-top: 1.4rem;
    border-top: 1px solid #e5ece7;
  }
  .contact-action-links{
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    margin-top: 1.5rem;
  }
  .contact-action-link{
    display: inline-flex;
    align-items: center;
    gap: 0.55rem;
    padding: 0.8rem 1rem;
    border-radius: 14px;
    font-family: Mulish;
    font-size: 12px;
    font-weight: 700;
    transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;

    i{
        font-size: 18px;
    }

    &:hover{
        transform: translateY(-1px);
        box-shadow: 0 10px 22px rgba(7, 30, 22, 0.12);
    }
  }
  .live-chat-link{
    background: #f4f8f5;
    color: #16372d;
    border: 1px solid #d9e6dd;
  }
  .whatsapp-link{
    background: #25D366;
    color: #fff;
    border: 1px solid #25D366;
  }
  .social-connect-section{
    margin-top: 1.5rem;
    padding-top: 1.4rem;
    border-top: 1px solid #e5ece7;
  }
  .social-connect-title{
    margin: 0 0 0.85rem;
    font-family: Mulish;
    font-size: 15px;
    font-weight: 800;
    color: #16372d;
  }
  .social-connect-links{
    display: flex;
    flex-wrap: wrap;
    gap: 0.7rem;
  }
  .social-connect-link{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    color: #fff;
    font-size: 18px;
    transition: transform 0.2s ease, box-shadow 0.2s ease, opacity 0.2s ease;

    &:hover{
        transform: translateY(-1px);
        box-shadow: 0 10px 22px rgba(7, 30, 22, 0.12);
        opacity: 0.95;
    }
  }
  .facebook-link{
    background: #1877F2;
  }
  .instagram-link{
    background: linear-gradient(135deg, #f58529, #dd2a7b 55%, #8134af);
  }
  .twitter-link{
    background: #1DA1F2;
  }
  .linkedin-link{
    background: #0A66C2;
  }
  .youtube-link{
    background: #FF0000;
  }
  .contact-text{
        font-family: Mulish;
        font-size: 13px;
        color: #012B20;

        span {
            font-family: Mulish;
            font-size: 15px;
        }
    }
  .border{
    border-left: solid 0px #ccc;
    padding: 1.5rem;
  }
  .bd{
    padding: 1.5rem;
  }
  .contact-banner{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 10px;
    font-family: Mulish;
    padding: 1.8rem;

    label{
        font-size: 12px;
        font-weight: 700;
        color: #012B20;
    }

    .form-control{
        font-size: 12px;
        font-family: Mulish;
        border: 1px solid #dbe4de;
        border-radius: 14px;
        min-height: 48px;
    }
    .input-contact{
        margin-top: 10px;
        color: #fff;
        border-radius: 14px;
        height: 48px;
        font-weight: 700;
    }
  }


  .text-banner{
    display: flex;
    flex-direction: column;
    padding: 0.6rem;
    font-family: Mulish;
    width: 50%;
    p{
        text-align: justify;
    }

    .our-vision{
        margin: 4px;
        font-family: Mulish;
        font-size: 13px;

        .company{
            font-weight: bold;
        }
        .mission{
            font-weight: bold;
        }
        .vision{
            font-weight: bold;
        }
        .impact{
            font-weight: bold;
        }
    }
  }

  .overlay3 {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    opacity: 3.9;
    //background: #012B20;
  }

  .content-footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: flex-start;
    gap: 1.5rem;
    padding-top: 2.7rem;
    padding-bottom: 2rem;
    padding-left: 5%;
    padding-right: 5%;
    color: #fff;
    background: #012B20;
  }
  .footer-img{
    display: flex;
    flex-direction: column;
    text-align: left;
    max-width: 320px;
  }
  .content-footer-text{
    font-family: Mulish;
    font-size:12px;
    font-weight: 500;
    text-align: center;
    word-wrap: break-word;
    width: 40em; 
    color: #fff;
  }
  
  .contact-info{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 0.8rem;

    img{ width:72px }

    p{
        font-family: Mulish;
        font-size:13px;    
        margin: 0;
        color: rgba(255,255,255,0.84);
    }
    a{
        text-decoration: none;
        color: #fff;
    }
  }
  .contact-title{
    font-size: 18px !important;
    font-weight: bold;
    text-transform: capitalize;
    color: #fff;
  }

  .services-title{
    font-size: 16px !important;
    font-weight: bold;
    text-transform: capitalize;
    color: #fff;
  }

  .copyright{
    font-family: Mulish;
    font-size:13px;
    font-weight: 400;
    text-align: left;
    padding-left: 5%;
  }
  
  .input-control {
    height: 30px;
    font-size: 12px;
    font-family: Mulish;
}
  .modal-mask {
    position: fixed;
    //z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #f5f9f711;
    display: table;
    transition: opacity .5s ease;

    &>div {
        width: 80%;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border: 0.5px solid #37ABC8;
        background: #f2f3f2;
        backdrop-filter: blur(13px);
        border-radius: 10px;
        box-sizing: border-box;
        font-family: Mulish;
    }

    h3 {
        margin-top: 10px;
        font-size: 18px;
        color: #000;
        font-weight: bold;
        font-family: Mulish;
    }

    span {
        margin-bottom: 20px;
    }

}

.modal-close {
    color: #000;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;

    &:hover {
        color: #fff;
    }
}
.modal-close-mobile {
    color: #000;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;

    &:hover {
        color: #FFF;
    }

    display: none;
}
.top {
    position: fixed;
    bottom: 0px;
    right: 0px;
    z-index: 1000;
    display: block;
    z-index: 9999;
    background: #012B20;
    color: #fff;
    border-radius: 45px;
    padding: 10px;
    transition: visibility 0.5s, opacity 0.5s;

    a{
        color: #fff;
    }
}
.hidden {
    visibility: hidden;
    opacity: 0;
}

.contact-support{
    position: fixed;
    bottom: 20px;
    right: 80px;
    z-index: 9999;
    background: #ccc;
    color: #fff;
    border-radius: 12px;
    transition: visibility 0.5s, opacity 0.5s;

    img{
        width: 60px;
    }
}
@media (min-width:320px) and (max-width: 720px) {

.top-header{
    font-size: 10px;
}
.haddress{
    display: flex;
    flex-direction: column;
    font-family: Mulish;
    font-size: 10px;
}
.core-values{
    display: flex;
    flex-direction: column;
    background: transparent;
    gap: 1rem;
    padding: 2rem 1rem !important;

    h3{
        font-family: Mulish;
        font-size: 24px;
        font-weight: 750;
        color: #16372d;
        text-align: left;
    }
    span{
        font-family: Mulish;
        font-size: 14px;
        font-weight: 300;
        text-align: left;
    }
}
.header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.menu-bar {
    display: flex; 
    flex-direction: column; 
    height:70px;
}

.menu-bar1{
    display:block;
    .fa-bars{
        font-size: 40px;
        cursor: pointer;
    }
 }
 .menu-bar1:hover{
    
        .submenu-bar1{
            display: flex;
            flex-direction: column;
            right: 0;
            font-family: Mulish;
            font-size: 13px;
            border-right: solid 1px rgba(0, 0, 0, 0.3);;
            background: #012B20;
            position: fixed;
            z-index: 9998;
            //padding: 0px 30px 0px 30px;
            //margin-top:-40px;
            width: 100%;
            height: auto;
                                  
            a{
                text-decoration: none;
                color: #fff;
            }
        }
        .sub-menu1{
            display: flex;
            flex-direction: row;
            justify-content: left;
            align-items: center;
            border-left: solid 0px #ccc;
            border-bottom: solid 1px #ccc;
            text-transform: capitalize;
            cursor: pointer;
            padding: 0.8rem;
            width: 100%;
        }
 }
 .sub-menu1:hover{
    background: #f0f6f1;
    color: #012B20 !important;
 }

.guarantee{
    min-height: auto;
    margin-top: 0;
    padding: 1.25rem;
}
.guarantee-icon{
    width: 56px;
    height: 56px;
    border-radius: 16px;
    margin-bottom: 1rem;
}
.size-all{
    font-size: 22px;
}
.guarantee-label{
    font-size: 10px;
}
.card{
    margin-top: 2%;
    border: solid 0px;
    border-bottom: solid 1px #fff;
    background: #8000808f;
}

.card-link{
    display: flex;
    flex-direction: row;
    justify-content: left;
    align-items: center;
    font-size: 14px; 
    font-weight: 450;
    font-family: Mulish;
    height: 20px;
    color: #000;
   
}
.card-header{
    border-bottom: solid 1px #fff;
}
.card-body{
    font-size: 13px; 
    font-family: Mulish;
    color: #fff;
}

.bg-task{
    display: flex;
    flex-direction: column;
    padding: 0rem;

    h2{
        font-size: 30px; 
        font-weight: 600;
        font-family: Mulish;

    }
    p{
        font-size: 12px; 
        font-weight: 400;
        font-family: Mulish;

    }
    img{
        width: 90% !important;
    }
    .btn{
        margin-bottom: 10px;
    }
    .task-img{
        display: none;
    }
}
      .bg-style{
    display:flex;
        flex-direction: column;
        position: relative;
        backdrop-filter: blur(16px);
        background: url(../assets/bg1.jpg) no-repeat center;
        background-size: cover;
        gap: 1rem;
        padding: 2rem 1rem;

        .services-visual-card{
            width: 100%;
            padding: 1rem;
        }

    .mobile-img{

        p{
            font-size: 12px; 
            font-weight: 400;
            font-family: Mulish;
            color: #012B20;
        }
        img{
            width: 100%;
            max-width: 240px;
            border-radius: 10px;
         }
         .google-play{
            margin-top: 0.5rem;
            margin-bottom: 10px;
            text-align: center;
            width: 50%;
            cursor: pointer;
            display: block;
         }
    }


    img{
        width: 100%;
        display: none;
    }
    .platform{
        display:flex;
        flex-direction: column;
        width: 100%;
        padding: 1.2rem;
        gap: 0.9rem;

        .select-item{
            margin: 0;
            padding: 0.9rem 1rem;
            font-size: 14px !important; 
            font-weight: 600;
            font-family: Mulish;
            color: #012B20;
        }
        .services-grid{
            grid-template-columns: 1fr;
        }

        h2{
            font-size: 28px; 
            font-weight: 700;
            font-family: Mulish;
        }
        span{
            font-size: 14px; 
            font-weight: 350;
            font-family: Mulish;
        }
    }
}

#dailytask{
    display: flex;
    flex-direction: column;  
    justify-content: center; 
    align-content: center;
    width: 100%;

    h2{
        font-family: Mulish;
        margin-top: -40px;
        z-index: 9666;
        color: #000000c0;
    }

    p{
        font-family: Mulish;
        font-size: 12px;
    }
    img{
        width: 120%;
    }
}

#dailytask .d-flex .flex-column .pt-0 .mt-0 {
    display: flex;
    flex-direction: column;
  
}
   
    .sidebar {
        width: auto;
        height: auto;
        position: fixed;
        z-index: 9998;
        transition: opacity .4s ease;
        background-color: rgba(0, 0, 0, .5);
        border-radius: 0px;
        margin-left: 10px;

        a{
            color: #37ABC8;
        }
        .close{
            margin-left: 20px;
        }
    }
    .sidebar a {float: left;}
    div.content {margin-left: 0;}

   .logo{
     img{ width: 50px; height: 50px; }
    }
    
    .fa-bars {
        display: block;
        font-size: 50px;
        cursor: pointer;
        color: #fff;
    }
    .menu {
        display: none;
    }
    .banner{
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 9.5rem 1rem 2rem;
        bottom: 0;
        font-family: Mulish;
        font-size: 18px;
        //background:#800080e6;
        overflow: hidden;
        position: relative;
        backdrop-filter: blur(16px);
        background: url(../assets/bg.jpg) no-repeat fixed center;
        background-size: cover;
        
        h1{
            font-family: Mulish;
            font-weight: 700;
            font-size: 40px;
            color: #fff;
            text-align: center;
            //text-shadow: 0px 1px #000; 
        }
        h4{
            font-family: Mulish;
            font-weight: 400;
            font-size: 18px;
            color: #fff;
            text-align: center;
            //text-shadow: 0px 1px #000; 
        }
        .btn-style{
            font-family: Mulish;
            text-align: center;
        }
        .img-style{
            display: flex;
            flex-direction: row;
            justify-content: center;
            img{
                text-align: center;
                width: 250px;
                display: none;
            }
        }
        .img-style1{
            display: flex;
            flex-direction: row;
            justify-content: center;
            img{
                text-align: center;
                width: 250px;
            }
        }
    }
    .banner-copy{
        width: 100%;
    }
    .banner-side{
        width: 100%;
    }
    .banner-login-card{
        max-width: 100%;
        padding: 1.4rem;
        border-radius: 18px;
        margin-top: 1.5rem;
    }
    .banner-login-header{
        h3{
            font-size: 24px;
            text-align: left;
        }
        span{
            text-align: left;
        }
    }
    .banner-login-links{
        flex-direction: row;
        align-items: flex-start;
    }
    .action-botton{
        margin-top: 50px;
    }
    .action-botton2{
        margin-top: 50px;
    }
    .content-services{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .content-row{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 80%;
      }
      .content-items{
        box-sizing: border-box;
        width: 100%;
      }
      
      .about{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: stretch;
        text-align: left;
        bottom: 0;
        font-family: Mulish;
        font-size: 10px;
        background: #33aacb14;
        background-size: cover;
        margin-top: 120px;
        box-shadow: -1px -1px 4px #ccc;
        position: relative;
        backdrop-filter: blur(16px);
        background-size: cover;
        padding: 2rem 1rem 2.5rem;
        gap: 1.5rem;

        .about-copy{
            gap: 0.8rem;
        }
        .about-label{
            font-size: 10px;
        }
        h2{
            font-size: 28px;
            text-align: left;
        }
        .about-text{
            font-size: 14px;
            line-height: 1.7;
        }
        .about-highlights{
            flex-direction: column;
        }
        .about-highlight{
            width: 100%;
        }
        .about-cta-panel{
            width: 100%;
        }
        .about-cta-card{
            max-width: 100%;
            padding: 1.4rem;
            border-radius: 20px;
        }

        .try-us{
            padding: 0;
            font-family: Mulish;
            font-size: 24px;
            font-weight: bold;
            color: #012B20;
        }
        .btn-account{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-content: center;
    
            .sign-in{
                font-family: Mulish;
                font-size: 16px;
                font-weight: bold;
                border: solid 0px #ccc;
                border-radius: 999px;
                background: #659610;
                width: 100%;
                margin-bottom: 10px;
                margin-right: 0;
            }
            .sign-up{
                font-family: Mulish;
                font-size: 16px;
                font-weight: bold;
                border: solid 0px #ccc;
                border-radius: 999px;
                background: #012B20;
                width: 100%;
            }
        }
    
        h4{
            font-family: Mulish;
            font-size: 17px;
            font-weight: bold;
            text-align: left;
        }
        p{
            font-family: Mulish;
            font-size: 13px;
        }
      }
      .team{
        display: flex;
        flex-direction: column;
        margin-top: 15px;
        
        h4{
            margin-top: 15px;
        }
    
        .name{
            font-family: Mulish;
            font-size: 13px;
            font-weight: bold;
        }
        i{
            margin-top: -15px;
        }
      }
      .border{
        border-left: solid 0px #ccc;
        padding: 1.5rem;
      }
      .bd{
        padding: 1.5rem;
      }

      .contact{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: stretch;
        height: auto;
        bottom: 0;
        font-family: Mulish;
        font-size: 10px;
        background-size: cover;
        margin-top: 0px;
        height: auto;
        gap: 1rem;
        padding: 2rem 1rem;
    
        h4{
            font-family: Mulish;
            font-size: 14px;
            font-weight: 500;
            text-align: left;
        }
        span{
            font-family: Mulish;
            font-size: 11px;
            font-weight: 800;
        }
        img{
            width: 100%;
        }
      }

      .content-footer {
        display: flex;
        flex-direction: column;
        padding-top: 2.7rem;
        padding-bottom: 1.5rem;
        bottom: 0;   
        background: #012B20; 
        padding-left: 5%;
        padding-right: 5%;
        gap: 1.5rem;
      }
      .content-footer-text{
        font-family: Mulish;
        font-size:13px;
        font-weight: 500;
        text-align: center;
        word-wrap: break-word;
        width: 28em; 
        color: #000;
      }
      .social-media{
        display: flex;
        flex-direction: row;
        justify-content: center;
      
        p{
          font-size: 20px; 
        }
      }

    
      .modal-mask {
        position: fixed;
        //z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(244, 241, 241, 0.5);
        display: table;
        transition: opacity .4s ease;
    
        &>div {
            width: 80%;
            height: auto;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            border: 0.5px solid #37ABC8;
            background: #f4f7f5;
            backdrop-filter: blur(13px);
            border-radius: 10px;
            box-sizing: border-box;
            font-family: Mulish;
        }
    
        h3 {
            margin-top: 10px;
            font-size: 18px;
            color: #000;
            font-weight: bold;
            font-family: Mulish;
        }
    
        span {
            margin-bottom: 20px;
        }
    
    }
    .contact-info{
        display: flex;
        flex-direction: column;
        gap: 0.7rem;
    
        img{ width:72px }
    
        p{
            font-family: Mulish;
            font-size:13px;    
        }
      }
    .modal-close {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;

        &:hover {
            color: #FFF;
        }

        display: none;
    }
    .modal-close-mobile {
        color: #000;
        line-height: 50px;
        font-size: 140%;
        position: absolute;
        right: 0;
        text-align: center;
        top: 2;
        width: 70px;
        text-decoration: none;

        &:hover {
            color: #FFF;
        }

        display: block;
    }

}
</style>
